import { useCore } from '@/composables/core'
import type { CustomEventsContext } from '../types'

type StoreState = {
  routingConfig?: { config?: { frontdesk_url?: string } }
  app?: { language?: string; country?: string }
}

export default function (this: CustomEventsContext) {
  const { store } = useCore()
  const state = store.state as StoreState

  const url = '{base}/{language}-{country}/'
    .replace('{base}/', state.routingConfig?.config?.frontdesk_url)
    .replace('{language}', state.app?.language)
    .replace('{country}', state.app?.country)

  this.sendEvent('core.ehlo', {
    app_link: url,
    app_link_logout: `${url}logout`,
  })
}
